import React, { useEffect } from 'react';
import "./SelfLearning.scss";
import { useSearchQuery } from '../../services/SearchQueryContext';

/**
 * Course Material Container.
 * @param props
 * @returns {*}
 * @constructor
 */

function TopicMaterialContainer(props) {
    const {
        course_id,
        mySectionData,
    } = props;

    const { setNewFlag } = useSearchQuery();

    useEffect(() => {
        setNewFlag(true);
        return () => setNewFlag(false);
    }, []);

    const getCourseSectionApiData = async () => {
        try {
            if (course_id !== undefined) {
                if (!props.activeItem && typeof mySectionData != "undefined") {
                    props.setActiveItem({
                        data: mySectionData?.data?.section[0],
                        sectionData: mySectionData
                    });
                }
            }
        } catch (error) {
            console.error('Error - ', error.message);
        }
    };

  useEffect(() => {
      getCourseSectionApiData();
  }, [course_id]);

    return (
        <></>
    );
}

export default TopicMaterialContainer;
